/** Width fingerprint for the overflow fit — excludes disabled: it never changes button width, and re-measuring on disabled toggles made the row flicker during data loads (JS-1180). */
export const getFunctionalButtonsLayoutKey = (
  buttons: { key: string; label: string }[]
): string =>
  buttons.map((button) => `${button.key}|${button.label}`).join('::');
